import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CreditCardIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 16" title={t`Credit Card`} {...props}>
    <Path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.25 10.222V11.5c0 .69.56 1.25 1.25 1.25h11c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25h-11c-.69 0-1.25.56-1.25 1.25v5.722ZM1.5 6h13M4 9.5h4"
    />
  </Icon>
);
